import { createRouter, createWebHashHistory } from "vue-router";
import Home from "@/views/Home.vue";
import CompanyInfo from "@/views/CompanyInfo.vue";
import UsedCarsSales from "@/views/UsedCarsSales.vue";
import AutoPartsSales from "@/views/AutoPartsSales.vue";
import Contact from "@/views/Contact.vue";
import ReviewContactContent from "@/views/ReviewContactContent.vue";
import CarInfo from "@/views/CarInfo.vue";
import PartInfo from "@/views/PartInfo.vue";

const routes = [
  { path: "/", component: Home },
  { path: "/company-info", component: CompanyInfo },
  {
    path: "/usedCarsSales",
    component: UsedCarsSales,
    // meta: { keepAlive: true },
  },
  {
    path: "/autoPartsSales",
    component: AutoPartsSales,
    // meta: { keepAlive: true },
  },
  { path: "/contact", component: Contact },
  { path: "/reviewContactContent", component: ReviewContactContent },
  { path: "/carInfo", component: CarInfo },
  { path: "/partInfo", component: PartInfo },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果保存了滚动位置（例如浏览器的后退/前进操作），则返回保存的位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则默认滚动到顶部
    return { top: 0, left: 0 };
  },
});

export default router;
